const use = {
  WRONG_PASSWORD_FORMAT: {
    message: 'A senha ainda está muito fraca!',
    field: 'password',
    code: 'USE_1'
  },
  CONFIRMATION_DOES_NOT_MATCH_PASSWORD: {
    message: 'A confirmação não confere com a senha!',
    field: 'password',
    code: 'USE_2'
  },
  INCORRECT_PASSWORD: {
    message: 'Senha incorreta!',
    field: 'password',
    code: 'USE_3'
  },
  FORBIDDEN_PASSWORD: {
    message: 'Senha proibida!',
    field: 'password',
    code: 'USE_4'
  },
  USER_NOT_FOUND: {
    message: 'Usuário não encontrado',
    field: 'user',
    code: 'USE_5'
  },
  PASSWORD_ALREADY_SETTED: {
    message: 'Senha já definida',
    field: 'user',
    code: 'USE_6'
  },
  EMAIL_ALREADY_REGISTERED: {
    message: 'E-mail já cadastrado',
    field: 'email',
    code: 'USE_7'
  }
};

module.exports = use;
